import { render, staticRenderFns } from "./projectAdd.vue?vue&type=template&id=fb750d34&"
import script from "./projectAdd.vue?vue&type=script&lang=js&"
export * from "./projectAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports